import { useEffect } from "react";
import { isBrowser } from "./utils/isBrowser";

export const useOnClickOutside = <
  E extends Element | null | undefined = HTMLElement,
>(
  ref: React.RefObject<E>,
  handler?: (event: MouseEvent | TouchEvent) => void,
) => {
  useEffect(() => {
    if (!isBrowser) {
      return;
    }
    if (!handler) {
      return;
    }
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener, { passive: true });
    document.addEventListener("touchstart", listener, { passive: true });

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [handler, ref]);
};
